import dailyMessages from "./daily-messages";
import staffMessages from "./staff-messages";

export default [
    ...dailyMessages,
    ...staffMessages,
];
